import React from "react";
import { Typography, Avatar, Chip, Box, Divider } from "@mui/material";
import { SPACING, ICON_SIZES } from "../../theme/constants";

const ActivityCard = ({ activity, icon }) => {
  const date = new Date(activity.createdAt).toLocaleString();

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.paper",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          boxShadow: 4,
          transform: "translateY(-2px)",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: SPACING.sm,
          mb: SPACING.xs,
        }}
      >
        <Avatar
          sx={{
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            width: ICON_SIZES.lg,
            height: ICON_SIZES.lg,
          }}
        >
          {icon}
        </Avatar>
        <Box>
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, lineHeight: 1.2 }}
          >
            {activity.siteName || "Unknown Site"}
          </Typography>
          <Chip
            label={activity.type.replace(/_/g, " ")}
            size="small"
            variant="outlined"
            sx={{
              mt: 0.5,
              textTransform: "capitalize",
              fontSize: "0.7rem",
              height: 20,
            }}
          />
        </Box>
      </Box>

      <Typography variant="body2" color="text.primary" sx={{ mb: SPACING.xs }}>
        {activity.description}
      </Typography>

      <Divider sx={{ my: 1 }} />

      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block" }}
      >
        {date}
      </Typography>
    </Box>
  );
};

export default ActivityCard;
